import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/tab-item/tab-item.js';
      

      export interface Props {
     hug?: boolean;
     centerContent?: boolean;
     checked?: boolean;
     hasClose?: boolean;
     hasLeadingIcon?: boolean;
     hasTitle?: boolean;
     hasDivider?: boolean;
     hasBadge?: boolean;
     icon?: string;
     title?: string;
     disabled?: boolean;
     badgeType?: string;
     badgeSize?: string;
     badgeShowNumber?: boolean;
     badgeCount?: number;
     showLeadingBadgeIcon?: boolean
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTabItem',
  props: {
    hug: { type: Boolean },
    centerContent: { type: Boolean },
    checked: { type: Boolean },
    hasClose: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    hasTitle: { type: Boolean },
    hasDivider: { type: Boolean },
    hasBadge: { type: Boolean },
    icon: {},
    title: {},
    disabled: { type: Boolean },
    badgeType: {},
    badgeSize: {},
    badgeShowNumber: { type: Boolean },
    badgeCount: {},
    showLeadingBadgeIcon: { type: Boolean }
  },
  emits: ["tab-click", "tab-close"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onTabClick: (event: CustomEvent<{title: string}>) => emit('tab-click', event as CustomEvent<{title: string}>),
onTabClose: (event: CustomEvent<{title: string}>) => emit('tab-close', event as CustomEvent<{title: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-tab-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})